import axios from "axios"
import $ from "jquery"
import { urlHelper } from "@/components/mixins/urlHelper"

export const UserService = Object.freeze({
  GetUser: function () {

    var reqUrl = window.appGlobals.API_URL + "appian/GetUser?siteKey=" + window.appGlobals.SITE_KEY;
    return axios.get(reqUrl);
  },
GetUserAndAvailableAccounts: function (siteKey) {
    let reqUrl = window.appGlobals.API_URL + "appian/GetUserAndDealerAuth?siteKey=" + siteKey
    return axios.post(reqUrl)
  },

  GetAvailableAccountsAndBrandAuth: function (dealerCode, userId, userDealerRange) {
    var dealerRange = { Range: userDealerRange }
    let reqUrl = window.appGlobals.API_URL + "appian/GetDealerCodesAndBrandAuth?dealerCode=" + dealerCode + "&userId=" + userId
    return axios.post(reqUrl, dealerRange)
  },
  AccountDetails: function () {
    return axios.get(window.appGlobals.API_URL + "AccountDetails")
  },
  UpdateActiveDealerCode: function (dealerCode, dealerRange, userId) {
    var updateDealerCodeDto = { 
      DealerCode: dealerCode,
      DealerRange: dealerRange,
      UserId: userId,
      SiteKey: window.appGlobals.SITE_KEY
    }
    let reqUrl = window.appGlobals.API_URL + "appian/UpdateActiveDealerCode"
    return axios.post(reqUrl, updateDealerCodeDto)
  },
  GetLogoutUrl: function () {
    var reqUrl = window.appGlobals.API_URL + "appian/GetLogoutUrl"
    return axios.get(reqUrl)
  },
  ResetDn6Session: function (sessionVarString) {
    return axios.get("/WebServices/GlobalLoginWS.asmx/ResetSession?SessionVariables=" + sessionVarString)
  },
  GetAudienceAndExclusions (accountId, userId) {
    let reqUrl = window.appGlobals.API_URL + "Exclusions/GetAudiencesAndExclusionsForUser?accountId=" + accountId + "&userId=" + userId
    return axios.get(reqUrl)
  },
   GetMCFEDealerSupportSites: function (dealerCode, userId, userDealerRange) {
    var dealerRange = { Range: userDealerRange }
    let reqUrl = window.appGlobals.API_URL + "appian/GetMCFEDealerSupportSites?dealerCode=" + dealerCode + "&userId=" + userId
    return axios.post(reqUrl, dealerRange)
  },
})
